// 任务日历管理 API
import { createAppRequest } from '@/services/request';

const request = createAppRequest();
// ==================== 任务日历管理 API ====================

// 任务日历相关接口
export const taskCalendarApi = {
  // 获取任务日历事件
  getCalendarEvents: (params?: {
    startDate?: string;
    endDate?: string;
    taskId?: string;
  }) => {
    const searchParams = new URLSearchParams();
    if (params?.startDate) {
      searchParams.append('startDate', params.startDate);
    }
    if (params?.endDate) {
      searchParams.append('endDate', params.endDate);
    }
    if (params?.taskId) {
      searchParams.append('taskId', params.taskId);
    }

    return request<{
      events: Array<{
        id: string;
        title: string;
        start: string;
        end: string;
        taskId: string;
        type: 'task' | 'deadline' | 'milestone';
        color?: string;
      }>;
    }>(`/bff/tasks/calendar?${searchParams.toString()}`, {
      method: 'GET',
    });
  },

  createCalendarEvent: (data: {
    title: string;
    start: string;
    end: string;
    taskId?: string;
    type: 'task' | 'deadline' | 'milestone';
    color?: string;
  }) =>
    request<{ id: string }>('/bff/tasks/calendar', {
      method: 'POST',
      data,
    }),

  updateCalendarEvent: (
    eventUuid: string,
    data: {
      title?: string;
      start?: string;
      end?: string;
      color?: string;
    },
  ) =>
    request<{ id: string }>(`/bff/tasks/calendar/${eventUuid}`, {
      method: 'PUT',
      data,
    }),

  deleteCalendarEvent: (eventUuid: string) =>
    request<void>(`/bff/tasks/calendar/${eventUuid}`, {
      method: 'DELETE',
    }),

  // 获取任务时间线
  getTaskTimeline: (params?: {
    taskId?: string;
    startDate?: string;
    endDate?: string;
  }) => {
    const searchParams = new URLSearchParams();
    if (params?.taskId) {
      searchParams.append('taskId', params.taskId);
    }
    if (params?.startDate) {
      searchParams.append('startDate', params.startDate);
    }
    if (params?.endDate) {
      searchParams.append('endDate', params.endDate);
    }

    return request<{
      timeline: Array<{
        id: string;
        type:
          | 'task_created'
          | 'task_updated'
          | 'task_completed'
          | 'task_assigned';
        timestamp: string;
        description: string;
        actor: string;
        taskId: string;
      }>;
    }>(`/bff/tasks/timeline?${searchParams.toString()}`, {
      method: 'GET',
    });
  },
};
